import { sortBy } from '../utils';

const TaskTemplatesCache = {
  list: null,
  dict: null,

  updateTemplates(templates) {
    const normalizedTemplates = templates.map(this.normalize);

    this.list = sortBy(normalizedTemplates, 'title');
    this.dict = this.list.reduce(
      (dict, template) => ({
        ...dict,
        [template.id]: template,
      }),
      {}
    );
  },

  updateSingleTemplate(template) {
    if (this.dict[template.id]) {
      const normalizedTemplate = this.normalize(template);
      this.dict[normalizedTemplate.id] = { ...normalizedTemplate };
      const index = this.list.findIndex(({ id }) => id === normalizedTemplate.id);
      if (index > -1) {
        this.list[index] = this.dict[normalizedTemplate.id];
      }
    }
  },

  removeSingleTemplate(templateId) {
    this.dict[templateId] = null;
    this.list = this.list.filter((template) => template.id !== templateId);
  },

  normalize(template) {
    const normalizedTemplate = { ...template };

    if (template.id) {
      normalizedTemplate.id = Number(template.id);
    }

    if (template.subtasks) {
      normalizedTemplate.subtasks = template.subtasks.map((subtask) => {
        if (typeof subtask === 'string') {
          return { title: subtask.trim() };
        }
        return subtask;
      });
    } else {
      normalizedTemplate.subtasks = [];
    }

    return normalizedTemplate;
  },

  clear() {
    this.list = null;
    this.dict = null;
  },
};

export default TaskTemplatesCache;
